<template>
  <div class="fans-follow-container">
    <div class="top">
      <div class="tabs">
        <div
          class="tab-item active"
        >
          我的推荐
        </div>
      </div>
      <div class="search-box">
        <input
          v-model="query.keyword"
          placeholder="搜索关键词搜索"
          type="text"
          @keyup.enter="onSearch"
        />
        <img
          @click="onSearch"
          src="../../assets/images/icon-search-workbench.png"
        />
      </div>
    </div>
    <div class="fans-box">
      <div
        class="list-item"
        v-for="(item, index) in infiniteList"
        :key="`fans-${index}`"
      >
        <div class="item-container">
          <div class="info">
            <img :src="item.avatar | default_img" />
            <div class="user-info">
              <div class="nick-name">{{ item.nickname }}</div>
              <div class="job-city">
                {{ item.job }} <span v-if="item.job && item.city">|</span>
                {{ item.city || "地球" }}
              </div>
              <div class="user-data">
                <div class="item">
                  笔记<span>{{ item.create_num }}</span>
                </div>
                <div class="item">
                  款式创建<span>{{ item.design_num }}</span>
                </div>
                <div class="item">
                  粉丝<span>{{ item.fans_num }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-box">
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GetInviteList
} from "@/api/social";
import infiniteMixin from "@/mixins/infinite";
export default {
  components: {  },
  data() {
    return {
      query: {
        status: "99",
        keyword: "",
      },
      
      fully_footer: false,
      loading_more: false,
      show_group: false,
      is_creating: false,
    };
  },
  mixins: [infiniteMixin],
  watch: {
    "query.status": {
      handler(newsVal, oldsVal) {
        if (newsVal === oldsVal) return;
        console.log("news", newsVal);
        this.getInfiniteList(true);
      },
      deep: true,
    },
  },
  computed: {
    is_login() {
      return this.$store.state.is_login;
    },
  },
  mounted() {
    this.getInfiniteList(true);
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.$nextTick(() => {
        const el = this.$parent.$refs.footer.$el;
        if (!el) return;

        const rect = el.getBoundingClientRect();

        // 页面滚动到底部还剩 50px 时触发
        const offsetBottom = rect.top - window.innerHeight;

        if (offsetBottom <= 50) {
          this.fully_footer = true;

          if (this.loading_more || this.infiniteEnded) return;

          this.loading_more = true;
          this.getInfiniteList().finally(() => {
            this.loading_more = false;
          });
        } else {
          this.fully_footer = false;
        }
      });
    },
    onSearch() {
      this.getInfiniteList(true);
    },
    async getInfiniteData(pageindex, pageSize) {
      try {
        const { keyword, status } = this.query;
        const param = { page: pageindex, limit: pageSize, keyword, status };
        const { data } = await GetInviteList(param);
        console.log("invite", data);
        return {data:data.list.length ? data.list : []};
      } catch (e) {
        console.log("e--infinite", e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./fansfollow.scss";
</style>
